import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import beforeLoginAxios from "../../../Util/API Calls/beforeLogin";

export const getDoctorList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    params: params,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.doctor_list && res.data.doctor_list.length > 0) {
      res.data.doctor_list.forEach((data) => {
        data.id = data.doctor_id;
        data.selected_doctor = false;
        data.label = data.doctor_name;
        data.value = data.doctor_first_name;
        data.name = data.doctor_name;
        data.initials = data.doctor_first_name.charAt(0);
      });
      return [res.data.doctor_list, false];
    }
  }
  return [[], true]; // [res, error]
};

const performApiRequest = async (api, payload) => {
  const res = await beforeLoginAxios({
    method: "post",
    url: api,
    data: payload,
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const enrollAadhar = async (api, payload) => {
  return performApiRequest(api, payload);
};

export const enrollVerifyOtp = async (api, payload) => {
  return performApiRequest(api, payload);
};

export const enrollResendOtp = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const linkMobileNumber = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const sendOtpToLinkMobileNumber = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const resendOtpToLinkMobileNumber = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const getAbhaAddressSuggestion = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const addAbhaAddress = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const downloadAbhaCard = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};

export const getAbhaProfile = async (api, payload) => {
  return performApiRequest(api, payload); // [response, error]
};
